import { Skeleton } from '@heroui/react';
import { Container } from '@school-manage/ui/Container/Container';
import { HeaderBar } from '@school-manage/ui/HeaderBar/HeaderBar';
import { NavigationBar } from '@school-manage/ui/NavigationBar/NavigationBar';
import { useTranslation } from 'react-i18next';

import { NftCardSkeleton } from './NftCardSkeleton';

export function ProfileSkeleton() {
  const { t } = useTranslation();

  return (
    <>
      <HeaderBar title={t('profile')} />
      <Container hasNavigationGap={false}>
        <div className="flex flex-col items-center gap-y-2">
          <Skeleton className="mb-2 size-60 rounded-lg" />

          <Skeleton className="h-6 w-60 rounded-lg" />
          <Skeleton className="h-8 w-1/5 rounded-lg" />
        </div>

        <Skeleton className="h-6 w-1/4 rounded-lg" />
        <div className="grid grid-cols-2 gap-4">
          <NftCardSkeleton count={2} />
        </div>
      </Container>
      <NavigationBar />
    </>
  );
}
